import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Workspace } from '../entities';
import { Observable } from 'rxjs';
import { WorkspaceApi } from '@keeps-platform-frontend-workspace/kp-keeps';

@Injectable({ providedIn: 'root' })
export class WorkspaceService extends EntityCollectionServiceBase<Partial<Workspace>> {
  constructor(
    serviceElementsFactory: EntityCollectionServiceElementsFactory,
    private workspaceApi: WorkspaceApi,
  ) {
    super('Workspace', serviceElementsFactory);
  }

  override update(entity: Partial<Partial<Workspace>>): Observable<Partial<Workspace>> {
    const {
      theme_dark,
      custom_color,
      name,
      doc_number,
      duns_number,
      description,
      address,
      city,
      state,
      post_code,
      country,
      id,
    } = entity;

    const updated = {
      id,
      theme_dark,
      custom_color,
      name,
      doc_number,
      duns_number,
      description,
      address,
      city,
      state,
      post_code,
      country,
    };

    const payload = {
      theme_dark,
      custom_color,
      name,
      doc_number,
      duns_number,
      description,
      address,
      city,
      state,
      post_code,
      country,
    };

    this.updateOneInCache(updated);
    return this.workspaceApi.updateWorkspace(entity.id, payload) as any as Observable<Partial<Workspace>>;
  }
}
